import { render, staticRenderFns } from "./sonstiges.vue?vue&type=template&id=30732bc4&"
import script from "./sonstiges.vue?vue&type=script&lang=js&"
export * from "./sonstiges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports